<template>
  <div
    class="chips-skeleton"
    :class="{ 'with-margin': withMargin }"
  >
    <SkeletonItem
      v-for="width of props.widths"
      :width="width"
      :height="32"
    />
  </div>
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';

  const props = defineProps<{
    widths: number[];
    withMargin?: boolean;
  }>();
</script>

<style scoped lang="scss">
  .chips-skeleton {
    display: flex;
    gap: 8px;
    overflow-x: hidden;
    max-width: 100%;

    &.with-margin {
      margin-top: 8px;
    }
  }
</style>
